import { isExists } from './is-exists';

/**
 * Is Object
 */
const isObject = <T>(target: T) =>
  isExists(target) && typeof target === 'object';

export { isObject };
